import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon from "@insite/mobius/Icon";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import Typography from "@insite/mobius/Typography";
import { TypographyProps } from "@insite/mobius/Typography/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AlertFill from "@store/Components/Icons/AlertFill";
import { getIsExternalLogin } from "@store/Store/Context/ContextSelectors";
import { scalableIconStyles, sideBoxStyles } from "@store/theme/common/mixins";
import parse from "html-react-parser";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import { css } from "styled-components";

const enum fields {
    title = "title",
    content = "content",
}

interface Props extends WidgetProps {
	fields: {
        [fields.title]: string;
        [fields.content]: string;
    };
}

export interface ChangePasswordSSORequirementsStyles {
	userInformationTitle?: TypographyProps;
	requirementsBox?: InjectableCss;
	requirementsIcon?: IconPresentationProps;
}

export const ChangePasswordSSORequirementsStyles: ChangePasswordSSORequirementsStyles = {
    userInformationTitle: {
        variant: "h4",
        as: "h2",
    },
    requirementsBox: {
        css: css`
            ${sideBoxStyles()}
        `,
    },
    requirementsIcon: {
        src: AlertFill,
        color: "primary",
        css: css`
            ${scalableIconStyles()}
            top: 0.125em;
            margin-right: 0.4em;
        `,
    },
};

const styles = ChangePasswordSSORequirementsStyles;

const ChangePasswordSSORequirements: FC<Props> = (props) => {
	const isExternalLogin = useSelector((state: ApplicationState) => {
		return getIsExternalLogin(state);
	})

	if (!isExternalLogin) {
		return null;
	}

    return (
        <>
			<StyledWrapper {...styles.requirementsBox}>
				<Typography {...styles.userInformationTitle}>
					<Icon {...styles.requirementsIcon} />
					{props.fields.title}
				</Typography>
				{parse(props.fields.content, parserOptions)}
			</StyledWrapper>
		</>
    );
};

const widgetModule: WidgetModule = {
    component: ChangePasswordSSORequirements,
    definition: {
        group: "Change Password",
        displayName: "SSO Requirements",
        allowedContexts: ["ChangePasswordPage"],
		fieldDefinitions: [
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "Requirements",
                fieldType: "Translatable",
            },
            {
                name: fields.content,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;
